import type React from 'react'
import './LogoAnimated.scss'

// ds-guard-ignore: màu logo thương hiệu, cố định
const LOGO_NAVY = '#015498'
// ds-guard-ignore: màu logo thương hiệu, cố định
const LOGO_BLUE = '#267DC4'
// ds-guard-ignore: màu logo thương hiệu, cố định
const LOGO_TEXT = '#154398'

type LogoAnimatedProps = {
  className?: string
}

/**
 * Logo IP VIETNAM dạng động, dùng cho splash screen.
 * Nguồn hình: `src/assets/images/ip_vietnam_logo.svg` — giữ nguyên path/màu.
 *
 * Hiệu ứng: vẽ viền trước (`stroke-dashoffset`) rồi mới đổ màu (`fill-opacity`).
 * `--i` là thứ tự xuất hiện, `--len` là độ dài viền để dasharray khỏi đoán bừa —
 * số lấy từ `getTotalLength()`: nếp gấp 1287, mỗi cánh 2313.
 */
const LogoAnimated = ({ className }: LogoAnimatedProps) => (
  <svg
    width="1367"
    height="1390"
    viewBox="-205 0 1367 1390"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className ? `logo-animated ${className}` : 'logo-animated'}
    role="img"
    aria-label="IP VIET NAM"
  >
    <path
      d="M388.665 533.496V180.496L547.665 420.496V776.496L388.665 533.496Z"
      fill={LOGO_NAVY}
      stroke={LOGO_NAVY}
      strokeWidth="10"
      style={{ '--i': 2, '--len': 1287 } as React.CSSProperties}
      className="logo-animated__draw"
    />
    <path
      d="M389.165 535.496V182.496C504.875 99.9778 584.225 87.3121 727.075 64.5108L727.165 64.4964C248.166 -139.004 -52.6471 161.796 7.66457 647.997C117.03 673.439 209.035 638.424 389.165 535.496Z"
      fill={LOGO_BLUE}
      stroke={LOGO_BLUE}
      strokeWidth="10"
      style={{ '--i': 0, '--len': 2313 } as React.CSSProperties}
      className="logo-animated__draw"
    />
    <path
      d="M547.665 772.496V420.496C692.652 339.626 776.278 318.07 928.665 312.496C1064.16 683.496 683.664 1155 220.665 894.496L217.665 891.996C398.515 861.539 477.859 837.586 547.665 772.496Z"
      fill={LOGO_BLUE}
      stroke={LOGO_BLUE}
      strokeWidth="10"
      style={{ '--i': 1, '--len': 2313 } as React.CSSProperties}
      className="logo-animated__draw"
    />
    <text
      x="478.5"
      y="1348"
      fontFamily="system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
      fontSize="208"
      fontWeight="600"
      fill={LOGO_TEXT}
      textAnchor="middle"
      letterSpacing="11"
      className="logo-animated__text"
    >
      IP VIET NAM
    </text>
  </svg>
)

export default LogoAnimated
